<div>
  <div class="relative sm:w-11/12 md:w-full bg-white rounded-lg" appScrollToTop>
    <div class="px-auto rounded-lg">
      <div class="p-0 lg:p-8 pt-2 pb-5">
        <h3
          class="hidden lg:block text-zestBlack font-semibold text-lg pt-10 pb-6 border-b"
        >
          Delivery Details
        </h3>
        <form
          [formGroup]="deliveryDetail"
          id="paymentForm"
        >
          <div class="py-2 w-full">
            <div formGroupName="addressDTO">

              <!-- ── First Name / Last Name ── -->
              <div class="flex pb-6 justify-between">
                <div class="grow w-1/2 mr-6">
                  <label
                    class="block pt-6 pb-2 font-normal leading-4 text-sm tracking-[0.01em] text-zestGrey"
                  >
                    First Name
                  </label>
                  <input
                    class="bg-white w-full h-14 outline-hidden placeholder-zestPlaceholder rounded border-[1px] border-solid border-[#c1c7d0] p-4 focus:border-zestGreen focus:ring-zestGreen"
                    type="text"
                    placeholder="First name"
                    name="first_name"
                    formControlName="first_name"
                    required
                  />
                  <span
                    class="text-red-500 pt-1"
                    *ngIf="
                      !deliveryDetail.get('addressDTO')?.get('first_name')?.valid &&
                      deliveryDetail.get('addressDTO')?.get('first_name')?.touched
                    "
                    >*First name is required</span
                  >
                  <span
                    class="block text-red-500 pt-1"
                    *ngIf="
                      deliveryDetail.get('addressDTO')?.get('first_name')?.hasError('pattern') &&
                      deliveryDetail.get('addressDTO')?.get('first_name')?.touched
                    "
                    >*Please input only alphabets in this field</span
                  >
                </div>
                <div class="grow w-1/2">
                  <label
                    class="block pt-6 pb-2 font-normal leading-4 text-sm tracking-[0.01em] text-zestGrey"
                  >
                    Last Name
                  </label>
                  <input
                    class="bg-white w-full h-14 outline-hidden placeholder-zestPlaceholder rounded border-[1px] border-solid border-[#c1c7d0] p-4 focus:border-zestGreen focus:ring-zestGreen"
                    type="text"
                    placeholder="Last name"
                    name="last_name"
                    formControlName="last_name"
                    required
                  />
                  <span
                    class="text-red-500 pt-1"
                    *ngIf="
                      !deliveryDetail.get('addressDTO')?.get('last_name')?.valid &&
                      deliveryDetail.get('addressDTO')?.get('last_name')?.touched
                    "
                    >*Last name is required</span
                  >
                  <span
                    class="block text-red-500 pt-1"
                    *ngIf="
                      deliveryDetail.get('addressDTO')?.get('last_name')?.hasError('pattern') &&
                      deliveryDetail.get('addressDTO')?.get('last_name')?.touched
                    "
                    >*Please input only alphabets in this field</span
                  >
                </div>
              </div>

              <!-- ── Email / Phone ── -->
              <div class="flex pb-6 justify-between">
                <div class="grow w-1/2 mr-6">
                  <label
                    class="block pb-2 font-normal leading-4 text-sm tracking-[0.01em] text-zestGrey"
                  >
                    Email
                  </label>
                  <input
                    class="bg-white w-full h-14 outline-hidden placeholder-zestPlaceholder rounded border-[1px] border-solid border-[#c1c7d0] p-4 focus:border-zestGreen focus:ring-zestGreen"
                    type="text"
                    placeholder="Enter email address"
                    name="email"
                    formControlName="email"
                    required
                  />
                  <div
                    class="text-red-500 pt-1"
                    *ngIf="
                      !deliveryDetail.get('addressDTO')?.get('email')?.valid &&
                      deliveryDetail.get('addressDTO')?.get('email')?.touched
                    "
                  >
                    <span
                      *ngIf="deliveryDetail.get('addressDTO')?.get('email')?.errors?.required"
                      >*Email address is required</span
                    >
                    <span
                      *ngIf="deliveryDetail.get('addressDTO')?.get('email')?.hasError('pattern')"
                      >*Email address is invalid</span
                    >
                  </div>
                </div>
                <div class="grow w-1/2">
                  <label
                    class="block pb-2 font-normal leading-4 text-sm tracking-[0.01em] text-zestGrey"
                  >
                    Phone Number
                  </label>
                  <div>
                    <div class="relative rounded-md shadow-sm">
                      <div class="absolute inset-y-0 left-0 flex items-center">
                        <label for="country" class="sr-only">Phone Number</label>
                        <select
                          id="phoneNumber"
                          name="countryCode"
                          required
                          autocomplete="phone"
                          class="h-full rounded-md border-transparent bg-transparent py-0 pl-3 pr-10 focus:border-zestGreen focus:ring-zestGreen sm:text-sm"
                        >
                          <option *ngFor="let code of codes">{{ code }}</option>
                        </select>
                      </div>
                      <input
                        type="tel"
                        name="phone"
                        id="phone-number"
                        formControlName="phone"
                        class="bg-white w-full h-14 outline-hidden rounded placeholder-zestPlaceholder border-[1px] border-solid border-[#c1c7d0] pl-[6rem] focus:border-zestGreen focus:ring-zestGreen"
                        placeholder="909876543"
                      />
                    </div>
                    <div>
                      <span
                        class="text-red-500 pt-1"
                        *ngIf="
                          !deliveryDetail.get('addressDTO')?.get('phone')?.valid &&
                          deliveryDetail.get('addressDTO')?.get('phone')?.touched
                        "
                        >*Phone number is required</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── Shipping Option ── -->
              <div class="flex">
                <div class="grow w-1/2">
                  <label
                    class="block pb-2 font-normal leading-4 text-sm tracking-[0.01em] text-zestGrey"
                  >
                    Shipping Option
                  </label>
                  <mat-select
                    id="region"
                    name="region"
                    formControlName="region"
                    placeholder="Select shipping method"
                    (selectionChange)="selectedValue($event)"
                    class="font-mont bg-white w-full h-14 outline-hidden rounded border placeholder-zestPlaceholder border-solid border-[#c1c7d0] p-3 focus:border-zestGreen focus:ring-zestGreen"
                  >
                    <mat-option
                      [value]="type"
                      *ngFor="let type of deliveryTypes"
                      class="font-mont"
                      >{{ type }}</mat-option
                    >
                  </mat-select>
                  <span
                    class="text-red-500 pt-1"
                    *ngIf="selectedShipping === 'select a shipping method'"
                    >*Please select a shipping option to proceed</span
                  >
                </div>
              </div>

              <!-- Discount Code -->
              <div class="text-left">
                <label
                  class="block pt-6 pb-2 font-normal leading-4 text-sm tracking-[0.01em] text-zestGrey"
                >
                  Got a discount code? Use it below
                </label>
                <div class="flex relative">
                  <input
                    class="bg-white h-[56px] w-full outline-hidden rounded-l border-[1px] border-solid border-[#c1c7d0] p-4
                           disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200
                           transition-colors duration-150  focus:border-zestGreen focus:ring-zestGreen"
                    [ngClass]="{
                      'border-zestGreen bg-green-50': discountAppliedSuccess,
                      'border-[#c1c7d0]': !discountAppliedSuccess
                    }"
                    type="text"
                    placeholder="Enter Code"
                    name="checkoutCode"
                    [(ngModel)]="discountCode"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="discountAppliedSuccess"
                    [attr.aria-label]="'Discount code'"
                  />

                  <!-- Apply button -->
                  <button
                    type="button"
                    (click)="applyDiscount()"
                    [disabled]="discountAppliedSuccess || isApplyingDiscount"
                    class="absolute right-1 top-1.5 px-5 py-3 w-28 rounded transition-all duration-200
                           disabled:cursor-not-allowed"
                    [ngClass]="{
                      'bg-zestGreen cursor-default': discountAppliedSuccess,
                      'bg-zestBlack hover:bg-gray-800': !discountAppliedSuccess && !isApplyingDiscount,
                      'bg-gray-400': isApplyingDiscount
                    }"
                  >
                    <!-- Loading spinner -->
                    <span
                      *ngIf="isApplyingDiscount"
                      class="flex justify-center items-center"
                    >
                      <svg
                        class="animate-spin h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          class="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8H4z"
                        ></path>
                      </svg>
                    </span>

                    <!-- Applied check -->
                    <span
                      *ngIf="discountAppliedSuccess && !isApplyingDiscount"
                      class="text-white flex justify-center items-center gap-1 font-medium text-sm"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                      </svg>
                      Applied
                    </span>

                    <!-- Default label -->
                    <span
                      *ngIf="!discountAppliedSuccess && !isApplyingDiscount"
                      class="text-white flex justify-center items-center font-medium text-sm"
                    >
                      Apply
                    </span>
                  </button>
                </div>
              </div>

              <!-- ── Pickup Info Banner ── -->
              <div
                *ngIf="selectedShipping === 'Pickup in store'"
                class="border border-ZTP-700 bg-ZTP-50 p-3 rounded-md mt-6"
              >
                <div class="flex items-center justify-start">
                  <img
                    src="../../../assets/svg/pickupWarn.svg"
                    alt="warn"
                    class="w-5"
                  />
                  <h5 class="font-semibold text-zestBlack text-sm pl-3">
                    Pickup Information
                  </h5>
                </div>
                <div class="">
                  <p
                    class="text-xs font-normal text-zestTertiary-700 pt-2 leading-4"
                  >
                    The Pickup address for your order will be sent to your email.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
